import {TourMembership, TourMembershipDTO} from "../models/membership";
import {authFetch} from "../auth/authFetch";

const API_BASE = "/api/account-tours";

/**
 * Holt alle Memberships eines Accounts.
 */
export async function getTourMembershipsByAccount(accountId: number): Promise<TourMembership[]> {
    const res = await authFetch(`${API_BASE}/${accountId}`);

    if (!res.ok) {
        throw new Error(`Failed to fetch memberships for account ${accountId}`);
    }

    return res.json();
}

/**
 * Holt eine einzelne Membership.
 */
export async function getTourMembership(accountId: number, membershipObjId: number): Promise<TourMembership> {
    const res = await authFetch(`${API_BASE}/${accountId}/${membershipObjId}`);

    if (!res.ok) {
        throw new Error(`Membership for account ${accountId} and membershipObjId ${membershipObjId} not found`);
    }

    return res.json();
}

/**
 * Legt eine neue Membership an.
 */
export async function createTourMembership(
    accountId: number,
    tourId: number,
    dto: Omit<TourMembershipDTO, "accountId" | "tourId">
) {
    const url = `${API_BASE}?accountId=${accountId}&tourId=${tourId}`;

    const res = await authFetch(url, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error("Failed to create membership");
    }

    return res.json();
}

/**
 * Aktualisiert eine bestehende Membership.
 */
export async function updateTourMembership(
    accountId: number,
    tourId: number,
    dto: Partial<TourMembershipDTO>
): Promise<TourMembership> {
    const url = `${API_BASE}?accountId=${accountId}&tourId=${tourId}`;

    const res = await authFetch(url, {
        method: "PATCH",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(`Failed to update membership for account ${accountId}`);
    }

    return res.json();
}

/**
 * Löscht eine Membership.
 */
export async function deleteTourMembership(accountId: number, tourId: number): Promise<void> {
    const url = `${API_BASE}?accountId=${accountId}&tourId=${tourId}`;

    const res = await authFetch(url, {
        method: "DELETE"
    });

    if (!res.ok) {
        throw new Error(`Failed to delete membership for account ${accountId}`);
    }
}

/**
 * Holt die Anzahl offener Membership-Anfragen für einen Account.
 */
export async function getCountOfOpenMembershipRequests(accountId: number): Promise<number> {
    const res = await authFetch(`${API_BASE}/openRequests/${accountId}`);

    if (!res.ok) {
        throw new Error(`Failed to fetch open membership requests for account ${accountId}`);
    }

    return res.json();
}